<template>
  <header id="commonHeader" :class="{open: nav}">
    <!-- ヘッダーロゴ部分 -->
    <p class="logo"><a href="/"><img src="/assets/images/mojiko_header_logo.svg" alt="もじこ"></a></p>
    <!-- ヘッダーメニュー部分 -->
    <nav class="nav">
      <ul>
        <li><router-link @click.native="nav = false" to="/#overview">製品情報</router-link></li>
        <li><router-link @click.native="nav = false" to="/news/">NEWS</router-link></li>
        <li><router-link @click.native="nav = false" to="/#examples">活用事例</router-link></li>
        <li><router-link @click.native="nav = false" to="/#price">価格</router-link></li>
        <li><router-link @click.native="nav = false" to="/faq/">FAQ</router-link></li>
        <li><router-link @click.native="nav = false" to="/terms/">利用規約</router-link></li>
        <li><a href="https://www.yoshidumi.com/privacy/" rel="noopener" target="_blank">プライバシー<br class="pcbr">ポリシー</a></li>
        <li><a href="/#contact">お問い合わせ</a></li>
      </ul>
    </nav>
    <!-- ハンバーガーメニュー部分 -->
    <div class="nav-toggle" @click="nav = !nav">
      <div>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <!-- 資料はコチラ部分 -->
    <div id="doc_balloon">
      <a href="https://www.yoshidumi.co.jp/document/doc-mojiko/" target="_blank">
        <img src="/assets/images/document_balloon.svg" alt="資料のダウンロードはコチラ">
      </a>
    </div>
  </header>
</template>

<script>
export default {
  data () {
    return {
      nav: false,
    }
  },
  mounted() {

  },
  methods: {

  },
  watch: {
    nav () {
      if (this.nav) {
        document.documentElement.style.overflow = 'hidden'
        return
      }
      document.documentElement.style.overflow = 'auto'
    },
  },
}
</script>

<style lang="stylus" scoped>
@media screen and (max-width: 767px)
  #commonHeader

    // ロゴは非表示
    .logo
      display none


    // ハンバーガーメニュー
    .nav-toggle
      display block
      position fixed
      z-index 1000
      top    20px
      right  20px
      height 32px
      cursor pointer

      > div
        position: relative
        width: 36px

      span
        width 100%
        height 3px
        left 0
        display block
        border-radius 10px
        background rgb(206, 223, 255)
        position absolute;
        transition transform .6s ease-in-out, top .5s ease

        &:nth-child(1)
          top 0

        &:nth-child(2)
          top 14px

        &:nth-child(3)
          top 28px



      &:hover span:nth-child(1)
        top 4px

      &:hover span:nth-child(3)
        top 23px



    // ナビゲーション
    .nav
      background $color-main
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      z-index 990
      width 100%
      color #fff
      text-align center
      display flex
      flex-direction column
      justify-content center
      align-items center
      // font-size: 26px;
      opacity 0
      pointer-events none
      transition opacity .6s ease, visibility .6s ease

      a
        display block
        color #fff
        text-decoration none
        padding 10px 0
        transition color .6s ease

        &:hover
          color #fff

      ul
        width 100%
        list-style none
        text-align left
        padding 0 $gap * 3
        li
          opacity 0
          font-size 1.3rem
          line-height 2rem
          transform translateX(200px)
          transition  transform .6s ease, opacity .2s ease

          &:nth-child(2)
            transition-delay .15s

          &:nth-child(3)
            transition-delay .3s

          &:nth-child(4)
            transition-delay .45s

          &:nth-child(5)
            transition-delay .6s

          &:nth-child(6)
            transition-delay .75s

          &:nth-child(7)
            transition-delay .9s

          &:nth-child(8)
            transition-delay: 1.05s



    // オープン時
    &.open
      overflow hidden

      .nav-toggle
        span
          background #fff

          &:nth-child(1)
            top 15px
            transform rotate(45deg)

          &:nth-child(2)
            top 15px
            width 0
            left 50%

          &:nth-child(3)
            top 15px
            transform rotate(-45deg)

      .nav
        pointer-events all
        opacity 1


      .nav li
        opacity 1
        transform translateX(0)
        transition transform 1s ease, opacity .9s ease


  #doc_balloon
    position fixed
    top calc(100% - 83px)
    left calc(100% - 89px)
    z-index 100
    opacity 0.8


@media screen and (min-width: 768px)
  #commonHeader
    width 100%
    height 72px
    position sticky
    top 0
    display flex
    justify-content space-between
    background #4471AF
    align-items center
    z-index: 20
    .logo
      margin 0
      padding 0
      height 100%
      a
        display flex;
        align-items center
        height 100%
        img
          width 55px
          margin-left 10px

    .nav
      height 100%
      width 100%
      display flex
      align-items center
      ul
        width 100%
        height 100%
        display flex
        flex-direction row
        justify-content flex-end
        li
          color #fff
          display flex
          justify-content center
          align-items center
          width 11%
          max-width 140px
          font-size 15px
          // font-weight: bold;
          line-height 20px
          padding 0 3px
          a, &:visited
            width 100%
            height 100%
            display flex
            justify-content center
            align-items center
            text-decoration none
            color #fff
            text-align center

          &:hover
            background alpha(#fff, .2)
            transition .4s ease-in

          &:nth-child(7)
            letter-spacing 0

          &:nth-child(8)
            background #23487D
            &:hover
              background alpha(#fff, .2)
              transition .4s linear

    .nav-toggle
      display none


  #doc_balloon
    position fixed
    top calc(100% - 98px)
    left calc(100% - 104px)
    z-index 100
    opacity 0.8

</style>
